import axios from "../axios-instance";
import {
  FEATURES_FETCH_START,
  FEATURES_FETCH_SUCCESS,
  FEATURES_FETCH_FAIL,
} from "../constants/featureAccess";

export const fetchUserFeatures = () => (dispatch) => {
  dispatch({ type: FEATURES_FETCH_START });
  axios
    .get("user-plan-features")
    .then((res) => {
      dispatch({
        type: FEATURES_FETCH_SUCCESS,
        payload: res.data.data,
      });
    })
    .catch((err) =>
      dispatch({
        type: FEATURES_FETCH_FAIL,
        payload: err.response?.data?.data,
      })
    );
};
